module.exports = __webpack_public_path__ + "img/touch-icon-ipad-retina.18c938cd.png";